(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("latexjs", [], factory);
	else if(typeof exports === 'object')
		exports["latexjs"] = factory();
	else
		root["latexjs"] = factory();
})(window, function() {
return 